import type { TranslationKey } from "../i18n.js";

/** Maps stable auth API codes to user-facing copy without exposing server details. */
export function authErrorTranslationKey(code: string, status: number, codeMode: boolean): TranslationKey {
  switch (code) {
    case "invalid_email": return "invalidEmail";
    case "email_registered": return "emailRegistered";
    case "rate_limited": return "rateLimited";
    case "email_unavailable": return "emailUnavailable";
    case "email_delivery_failed": return "emailDeliveryFailed";
    case "auth_service_unavailable": return "authServiceUnavailable";
    case "invalid_password": return "invalidPassword";
    case "password_required": return "passwordRequired";
    case "invalid_credentials": return "invalidCredentials";
    case "invalid_code_format": return "invalidCodeFormat";
    case "code_not_found": return "codeNotFound";
    case "code_expired": return "codeExpired";
    case "code_locked": return "codeLocked";
    case "invalid_code": return "invalidCode";
    case "turnstile_required": return "captchaRequired";
    case "turnstile_failed": return "captchaFailed";
    case "turnstile_unavailable": return "captchaUnavailable";
    default: return status >= 500 ? "authServiceUnavailable" : codeMode ? "invalidCode" : "authError";
  }
}
